<template> 
  <f7-page>

    <f7-block>
      <p>... înapoi la pagina de unde am pornit</p>
    </f7-block>

  </f7-page>
</template>

<script>
  export default {
    mounted() {
      window.location.href=localStorage.http_redirect_uri;
    }
  }
</script>
